import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import styled from '@emotion/styled'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { Button } from '@mobi/component-library/Base/Buttons'
import { spacing } from '@mobi/component-library/Foundations'
import { RadioGroupItem } from '@mobi/component-library/Selection&Input/CheckboxAndRadioGroups'
import { FormLayout } from './Layout.styled'
import { trackVerificationSelectOption } from '../../../Verification/Utils/ga'
import { getSignUpState } from '../../Store'
import { routes } from '../../Utils'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { useHostContextFeature } from '@mobi/account/Hooks'

export type Documents = 'licence' | 'passport' | 'medicare'

export const IdentityDocumentSelector = () => {
  const [selectedMethod, setSelectedMethod] = useState<Documents | undefined>(undefined)
  const navigate = useNavigate()
  const attemptsToVerify = useSelector(getSignUpState)?.numberOfAttemptsToVerify ?? 0

  const isAmlRiskAssessed = useHostContextFeature(FeatureFlags.AML_SIGNUP_RISK_ASSESSMENT.key)

  const onMethodSelected = (method: Documents) => {
    switch (method) {
      case 'licence':
        return navigate(routes.driversLicence)
      case 'medicare':
        return navigate(routes.medicare)
      case 'passport':
        return navigate(routes.passport)
    }
  }

  return (
    <FormLayout>
      <AccountHeader
        alignItems='start'
        title='How would you like to verify your identity?'
        description='To verify your identity we require additional documentation. Please select one of the options below.'
        style={{ marginBottom: '0rem' }}
      />
      <RadioGroup>
        <RadioGroupItem
          id='id-method-drivers-licence'
          size='sm'
          iconName='DuocolorCreditCard02'
          isChecked={selectedMethod === 'licence'}
          onClick={() => setSelectedMethod('licence')}
        >
          Driver's licence
        </RadioGroupItem>
        {!isAmlRiskAssessed && (
          <RadioGroupItem
            id='id-method-medicare-card'
            size='sm'
            iconName='DuocolorCertificate02'
            isChecked={selectedMethod === 'medicare'}
            onClick={() => setSelectedMethod('medicare')}
          >
            Medicare card
          </RadioGroupItem>
        )}

        <RadioGroupItem
          id='id-method-passport'
          size='sm'
          iconName='DuocolorPassport'
          isChecked={selectedMethod === 'passport'}
          onClick={() => setSelectedMethod('passport')}
        >
          Passport
        </RadioGroupItem>
      </RadioGroup>

      <footer style={{ rowGap: spacing.sm }}>
        <Button
          isFullWidth
          disabled={!selectedMethod}
          onClick={() => {
            trackVerificationSelectOption(selectedMethod, attemptsToVerify)
            onMethodSelected(selectedMethod as Documents)
          }}
        >
          Continue
        </Button>

        <Button
          color='tertiary_color'
          isFullWidth
          size='md'
          onClick={() => {
            trackVerificationSelectOption(selectedMethod, attemptsToVerify)
            navigate(routes.signUpUnsuccessful)
          }}
        >
          {`I don't have any of these documents`}
        </Button>
      </footer>
    </FormLayout>
  )
}

const RadioGroup = styled.div({ display: 'flex', flexDirection: 'column', gap: spacing.smx1 })
